var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var PER_PAGE = 5;

function LoadMore(el) {
	var itemSelector, filterClass, filterSelector,
		t = this;

	t.$el = $(el);
	t.currentPage = 0;

	t.filterClass = t.$el.data('filter-class');
	itemSelector = t.$el.data('item-selector');
	t.$allItems = $(itemSelector);

	t.update();

	t.$filters = $(t.$el.data('filters-selector'));

	t.$el.on('click', t.showItems.bind(t));

	t.$filters.on('change', t.update.bind(t));
}

LoadMore.prototype.showItems = function (e) {
	var count,
		t = this;
	t.currentPage ++;
	count = t.currentPage * PER_PAGE;
	var $nextElement = t.$items.slice(0, count).prevObject.not('.js-load-more-visible').first();
	t.$items.slice(0, count).addClass('js-load-more-visible');
	if (count < t.$items.length) {
		t.$el.fadeIn(300);
	} else {
		t.$el.fadeOut(300);
	}

	if (e && e.type) {
	  if ($nextElement.length) {
			setTimeout(function () {
					$nextElement.find('a')[0].focus();
			}, 400);
	  }
	}

	return count;
};

LoadMore.prototype.update = function () {
	var t = this;
	if (t.$items) {
		t.$items.removeClass('js-load-more-visible');
	}

	t.$items = t.$allItems.filter('.' + t.filterClass);
	t.currentPage = 0;
	t.showItems();
};

module.exports = LoadMore;
